module.exports = __webpack_public_path__ + "img/g.57e2a783.svg";